// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8x74V","title":"styles_title__KR54x","form":"styles_form__3ragz"};